import React from 'react';

type SubmisionProps = {
    userName: string,
    mhqp: boolean
};

const SubmissionStatus: React.FC<SubmisionProps> = ({ userName, mhqp = false }) => {

    const url = () => mhqp ? '/mhqppeslogin' : '/login';

    return <>
        <h2 className='mb-5'>Your password has been reset</h2>

        <div className='row mb-5'>
            <div className='col-12'>
                <p>
                    An email has been sent to {userName}. Included in the email is a link to reset your password. Check your inbox as well as junk 
                    and spam folders. If the email does not arrive, you may contact us
                    at <a href='maito:info@cssreseach.org'>info@cssreseach.org</a> or call 800-213-7283.                        
                </p>
            </div>
        </div> 

        <div className='row'>
            <div className='col-12 mb-4 text-left'>
                <a href={url()}>Return to login</a>
            </div>
        </div>          
    </>;
};

export default SubmissionStatus;